import { createSlice } from "@reduxjs/toolkit"
import { getCookie, setCookie } from "../utils/cookies"

const AGE_GATE_COOKIE_KEY = `agegate_${process.env.GATSBY_LOCALE}`

const app = createSlice({
  name: "agegate",
  initialState: {
    havePassed: true,
  },
  reducers: {
    setState: (state, action) => {
      return { ...state, ...action.payload }
    },
  },
})

export const checkAgeGate = () => async dispatch => {
  const hasCookie = !!getCookie(AGE_GATE_COOKIE_KEY)

  dispatch(
    setState({
      havePassed: hasCookie,
    })
  )
}

export const acceptAgeGate = () => async dispatch => {
  setCookie(AGE_GATE_COOKIE_KEY, true)

  dispatch(
    setState({
      havePassed: true,
    })
  )
}

export const { setState } = app.actions

export default app
